import { type ReactNode } from 'react'

import styles from './AudioLicense.module.css'

type TAudioLicenseProps = {
    icon: ReactNode
    title: string
    description: string
    learnMoreLabel: string
    learnMoreHref?: string
}

export const AudioLicense = ({
    icon,
    title,
    description,
    learnMoreLabel,
    learnMoreHref,
}: TAudioLicenseProps) => (
    <div className={styles.license}>
        <div className={styles.header}>
            {icon}
            <p className={styles.title}>{title}</p>
        </div>
        <p className={styles.description}>{description}</p>
        {learnMoreHref ? (
            <a
                className={styles.link}
                href={learnMoreHref}
                target="_blank"
                rel="nofollow noreferrer"
            >
                {learnMoreLabel}
            </a>
        ) : null}
    </div>
)
